import PropTypes from "prop-types"
import { upperFirst } from "lodash"
import { Card } from "@mui/material"
import ModelSelectorAutocomplete from "connected-components/model-selector-autocomplete"

export default function UploadHeader({ type = "portfolio", target, rolloverLegend, editableModel, models, setModel }) {
  return <Card elevation={1} square className="upload-card upload-target-detail">
    <div className="upload-target-name">
      {upperFirst(type)}<div className="detail-value">{target.name}</div>
    </div>
    <div className="upload-target-modelId">
      {!editableModel && target.model && <>Model <div className="detail-value">{target.model}</div></>}
      {editableModel && (
        <ModelSelectorAutocomplete
          className="model-selector"
          models={models || []}
          value={target.modelId}
          onChange={(modelId) => setModel({ target: { value: modelId } })}
          label="Select a model"
          inputId="modelId"
        />
      )}
    </div>
    {rolloverLegend && <div className="upload-target-live">
      {rolloverLegend}
    </div>}
  </Card>
}

UploadHeader.propTypes = {
  type: PropTypes.string.isRequired,
  target: PropTypes.object.isRequired,
  editableModel: PropTypes.bool,
  models: PropTypes.array,
  setModel: PropTypes.func,
  rolloverLegend: PropTypes.string,
}
